import { createContext, useContext } from "react";
import { TOOLS_DEFAULT_WIDTH } from "./toolsWidth";

export const ToolsPanelWidthContext = createContext<number>(TOOLS_DEFAULT_WIDTH);

/**
 * The measured width of the expanded tools panel, in px. Tool content reads this to lay itself
 * out by the panel's width rather than the viewport's. Outside a tools panel it reports the
 * default panel width.
 */
export const useToolsPanelWidth = () => useContext(ToolsPanelWidthContext);
